// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1AnyK","alertIcon":"ConfirmModal_alertIcon__KQ0ZD"};